import { useFeatureFlag } from './use-feature-flag';
import { Features } from '../../constants/features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableAIAutomationRule = () => {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableAIAutomationRule);
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(Features.AIAutomationRuleCreator);
  return isFeatureFlagEnabled && isSellerFeatureEnabled;
};
